// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bk-0";
export var headerCellHover = "_bk-1";
export var readCellContainer = "_bk-2";
export var readCellSlot = "_bk-3";
export var rowHoverCheckbox = "_bk-4";
export var rowUnreadIndicator = "_bk-5";
export var searchHighlight = "_bk-8";
export var supportTicketRow = "_bk-6";
export var unreadIndicator = "_bk-7";